import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import {
  DependencyChangeEntry,
  DependencyUpdateEntry,
} from '@flowx/designer/modules/ai/types/ai.types'

@Component({
  selector: 'flx-developer-dependency-summary',
  imports: [NgClass],
  templateUrl: './developer-dependency-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeveloperDependencySummaryComponent {
  added = input<DependencyChangeEntry[]>([])
  updated = input<DependencyUpdateEntry[]>([])
  removed = input<DependencyChangeEntry[]>([])

  showMore = true
}
